import '@stimulus/polyfills'
import 'chart.js'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu-shared-company-contract-results', class extends Controller {
  static targets = ["chart"]

  connect() {
    this.initializeChart()
  }

  initializeChart() {
    const chartElement = this.chartTarget

    if (!chartElement) {
      return
    }

    const { labels, values } = JSON.parse(chartElement.dataset.chart)

    new Chart(chartElement, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [{
          label: '件数',
          data: values,
          backgroundColor: (context) => {
            const currentIndex = context.dataIndex
            const datasetLength = context.dataset.data.length || 1
            const magnification = 1 / datasetLength
            const alpha = 1 - (magnification * (currentIndex - 1))

            if (currentIndex === 0) {
              return '#FDEC02' // 1番件数の多いものは黄色にする
            }
            return `rgb(0, 136, 255, ${alpha >= 1 ? 1 : alpha})`
          }
        }]
      },
      options: {
        legend: {
          position: 'left',
          align: 'start'
        }
      }
    })
  }
})
